import { useQuery } from '@tanstack/react-query'
import { TRANSACTIONS } from '../../constants/endpoints'
import { getTransactions } from '../../utils/getTransactions'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useTransactionsQuery = ({ enabled }: { enabled: boolean }) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [TRANSACTIONS, userId],
    queryFn: getTransactions,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
